<template>
	<div v-if="idx === 0">
		{{ column.label }}
	</div>
	<div v-else>
		<div v-if="columnObjLocal.value" class="is-flex is-justify-content-center is-align-items-center">
			<div style="cursor: pointer" @click="setColumnObj(undefined)">
				<b-icon icon="delete" color="black" />
			</div>
			<div>{{ columnObjLocal.value.attributes.name }}</div>
		</div>
		<div v-else>
			<div>{{ column.label }}</div>
			<b-field v-if="selectedBalance" type="is-danger" message="Wähle ein Budget!">
				<b-autocomplete placeholder="Budgets" :data="selectedBalance.attributes.budgets" icon="magnify"
					field="name" :clearable="true" :open-on-focus="true"
					@select="(option) => option ? setColumnObj(option) : setColumnObj(undefined)">
					<template #default="props">
						<div>{{ props.option.attributes.name }}</div>
					</template>
				</b-autocomplete>
			</b-field>
		</div>
	</div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
	name: "HeaderSelection",
	props: ["idx", "columnObj", "column", "selectedBalance"],
	data() {
		return {
			columnObjLocal: cloneDeep(this.columnObj) // Kopie erstellen
		}
	},
	methods: {
		setColumnObj(value) {
			this.columnObjLocal.value = value
			this.$emit('update:columnObj', { "selectedBalance": this.selectedBalance, "column": this.column, "columnObj": this.columnObjLocal, "idx": this.idx })
		}
	}
}
</script>

<style scoped></style>